<div class="delete-confirmation-dialog">
  <div class="dialog-header">
    <div class="warning-icon">
      <span class="material-icons">warning</span>
    </div>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  
  <div mat-dialog-content class="dialog-content">
    <p class="confirmation-message">{{ data.message }}</p>
    <div class="item-details">
      <strong>{{ data.itemType === 'group' ? 'Group:' : 'Subgroup:' }}</strong>
      <span class="item-name">{{ data.itemName || 'Unnamed Item' }}</span>
    </div>
    <p class="warning-text">
      <span class="material-icons warning-icon-small">info</span>
      This action cannot be undone.
    </p>
  </div>
  
  <div mat-dialog-actions class="dialog-actions">
    <button 
      mat-button 
      (click)="onCancel()" 
      class="cancel-button"
      cdkFocusInitial>
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="warn" 
      (click)="onConfirm()" 
      class="delete-button">
      <span class="material-icons">delete</span>
      Delete
    </button>
  </div>
</div>
